import { useEffect, useState } from 'react';
import api from '../../../plugins/api';
import Button from '../../../components/Button/Button';
import Select from '../../../components/Select/Select';
import alert from '../../../helpers/alert';
import { COLORS } from '../../../components/Selects/SelectColor';

/**
 * Ð¤Ð¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¿Ð¾ ÑÐ²ÐµÑÐ°Ð¼. Ð£ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð´Ð½Ð° Ð¾Ð±ÑÐ°Ñ ÐºÐ°ÑÑÐ¸Ð½ÐºÐ°,
 * Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ ÐºÐ»Ð¸ÐµÐ½Ñ Ð²Ð¸Ð´ÐµÐ» Ð¾Ð´Ð¸Ð½ Ð¸ ÑÐ¾Ñ Ð¶Ðµ ÑÐ½Ð¸Ð¼Ð¾Ðº Ð´Ð»Ñ Ð»ÑÐ±Ð¾Ð³Ð¾ ÑÐ²ÐµÑÐ°.
 */
const ContainerColorPhotos = ({ containerId }) => {
  const [groups, setGroups] = useState([]);
  const [color, setColor] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get('/api/crm/cars/containerColorPhotos', { containerId });
      setGroups(data || []);
    } catch (e) {
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð¿Ð¾ ÑÐ²ÐµÑÐ°Ð¼');
    }
  };

  useEffect(() => {
    if (containerId) load();
  }, [containerId]);

  const upload = async (event) => {
    const file = event?.target?.files?.[0];
    event.target.value = '';
    if (!file) return;

    if (!color?.value) {
      alert.error('Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð²ÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ²ÐµÑ');
      return;
    }

    const form = new FormData();
    form.append('containerId', containerId);
    form.append('color', color.value);
    form.append('photo', file);

    setLoading(true);
    try {
      await api.post('/api/crm/cars/uploadContainerColorPhoto', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert.success('Ð¤Ð¾ÑÐ¾ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¾');
      await load();
    } catch (e) {
      alert.error(e?.response?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¾');
    } finally {
      setLoading(false);
    }
  };

  const remove = async (id) => {
    setLoading(true);
    try {
      await api.post(`/api/crm/cars/deleteContainerColorPhoto?id=${id}`);
      await load();
    } catch (e) {
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÐ¾ÑÐ¾');
    } finally {
      setLoading(false);
    }
  };

  const nameOf = (value) =>
    COLORS.find((c) => c.value?.toUpperCase() === value?.toUpperCase())?.label || value;

  return (
    <div style={{ marginTop: 30 }}>
      <p style={{ fontWeight: 600, fontSize: 18, marginBottom: 15 }}>Ð¤Ð¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð¿Ð¾ ÑÐ²ÐµÑÐ°Ð¼</p>

      <div style={{ display: 'flex', gap: 15, alignItems: 'flex-end', marginBottom: 20 }}>
        <div style={{ minWidth: 240 }}>
          <Select
            options={COLORS}
            label="Ð¦Ð²ÐµÑ"
            placeholder="ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ²ÐµÑ"
            value={color}
            onChange={setColor}
          />
        </div>
        <label>
          <input type="file" accept="image/*" onChange={upload} style={{ display: 'none' }} disabled={loading} />
          <span
            style={{
              display: 'inline-block',
              padding: '12px 20px',
              borderRadius: 8,
              background: 'var(--brand-primary)',
              color: '#fff',
              cursor: loading ? 'default' : 'pointer',
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? 'ÐÐ°Ð³ÑÑÐ·ÐºÐ°â¦' : 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÑÐ¾ÑÐ¾'}
          </span>
        </label>
      </div>

      {groups.length === 0 ? (
        <p style={{ color: '#6A6A6A', fontSize: 14 }}>
          ÐÐ¾ÐºÐ° Ð½Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾ Ð½Ð¸ Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð¿Ð¾ ÑÐ²ÐµÑÐ°Ð¼ â Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑÑÑ Ð¾Ð±ÑÐµÐµ ÑÐ¾ÑÐ¾ Ð¼Ð¾Ð´ÐµÐ»Ð¸.
        </p>
      ) : (
        groups.map((group) => (
          <div key={group.color} style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  background: group.color,
                  border: '1px solid #ccc',
                  display: 'inline-block',
                }}
              />
              <span style={{ fontWeight: 500 }}>{nameOf(group.color)}</span>
              <span style={{ color: '#6A6A6A', fontSize: 13 }}>({group.photos?.length || 0})</span>
            </div>

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {group.photos?.map((photo) => (
                <div key={photo.id} style={{ position: 'relative' }}>
                  <img
                    src={photo.url}
                    alt={group.color}
                    style={{ width: 160, height: 100, objectFit: 'cover', borderRadius: 8 }}
                  />
                  <button
                    type="button"
                    onClick={() => remove(photo.id)}
                    title="Ð£Ð´Ð°Ð»Ð¸ÑÑ"
                    style={{
                      position: 'absolute',
                      top: 4,
                      right: 4,
                      border: 'none',
                      borderRadius: '50%',
                      width: 24,
                      height: 24,
                      background: 'rgba(0,0,0,0.6)',
                      color: '#fff',
                      cursor: 'pointer',
                      lineHeight: '24px',
                    }}
                  >
                    Ã
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ContainerColorPhotos;
